import { Calendar, TrendingUp } from 'lucide-react';

/**
 * Criteria the user must meet to make Private Introductions.
 *
 * Iter166 simplified the bar to two automatic signals: account age and a
 * real portfolio. Previously also gated on 2FA (personal choice), an
 * "onboarding_completed" flag (never wired up), and weeks-active (implied
 * by having added 3 investments).
 */
export const buildCriteriaDetails = (criteria) => [
  {
    key: 'account_age',
    title: 'Account Age',
    description: `Account must be at least 30 days old (Currently: ${criteria?.account_age_days || 0} days)`,
    icon: Calendar,
    met: criteria?.account_age || false,
    progress: Math.min(100, ((criteria?.account_age_days || 0) / 30) * 100)
  },
  {
    key: 'has_enough_investments',
    title: 'Active Portfolio',
    description: `Add at least 3 investments (Currently: ${criteria?.investment_count || 0}/3)`,
    icon: TrendingUp,
    met: criteria?.has_enough_investments || false,
    progress: Math.min(100, ((criteria?.investment_count || 0) / 3) * 100)
  }
];
